import { defineComponent as _defineComponent } from 'vue'
import { dir } from 'bits/current_dir'
import { HomePageCard, homepageCards } from 'bits/landside_helper'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from 'pinia/dark_mode'
import { useWindowSizeStore } from 'pinia/window_size'
import { onMounted, ref, watch } from 'vue'
import HomePageCareersCard from 'vuecomponents/HomePageCareersCard.vue'
import HomePageWallFormatCard from 'vuecomponents/HomePageWallFormatCard.vue'
import HomePageWelcomeCard from 'vuecomponents/HomePageWelcomeCard.vue'
import HomePageWorldwideUsersCard from 'vuecomponents/HomePageWorldwideUsersCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideHomePage',
  setup(__props) {

const { isDarkMode } = storeToRefs(useDarkModeStore())
const { windowWidth, isSmallerThanTabletPortrait, isSmallerThanDesktop } = storeToRefs(useWindowSizeStore())

const containerRef = ref<HTMLElement>()
const cardWidth = ref(0)

watch(windowWidth, calculateCardWidth)

onMounted(calculateCardWidth)

function calculateCardWidth(): void {
  const container = containerRef.value
  if (!container) return
  // Every card has the same width and height except the first card, so we can just use the second one
  cardWidth.value = container?.children[1].clientWidth
}

return { __sfc: true,isDarkMode, windowWidth, isSmallerThanTabletPortrait, isSmallerThanDesktop, containerRef, cardWidth, calculateCardWidth, dir, HomePageCard, homepageCards, HomePageCareersCard, HomePageWallFormatCard, HomePageWelcomeCard, HomePageWorldwideUsersCard }
}

})